"use client";
import { DatePicker as e, DatePickerContext as t } from "@ark-ui/react";
import { datePickerRecipe as i } from "@huspy/styled-system/recipes";
import { createStyleContext as l } from "../../utils/createStyleContext.mjs";
const { withProvider: o, withContext: a } = l(i), g = o(e.Root, "root"), n = a(e.ClearTrigger, "clearTrigger"), c = a(
  e.Content,
  "content"
), T = a(
  e.Control,
  "control"
), s = a(
  e.Input,
  "input"
), P = a(
  e.Label,
  "label"
), d = a(e.MonthSelect, "monthSelect"), b = a(e.NextTrigger, "nextTrigger"), p = a(e.Positioner, "positioner"), m = a(e.PresetTrigger, "presetTrigger"), y = a(e.PrevTrigger, "prevTrigger"), C = a(
  e.RangeText,
  "rangeText"
), k = a(e.TableBody, "tableBody"), D = a(e.TableCell, "tableCell"), N = a(e.TableCellTrigger, "tableCellTrigger"), w = a(e.TableHead, "tableHead"), x = a(e.TableHeader, "tableHeader"), R = a(
  e.Table,
  "table"
), V = a(e.TableRow, "tableRow"), S = a(
  e.Trigger,
  "trigger"
), H = a(e.ViewControl, "viewControl"), v = a(
  e.View,
  "view"
), h = a(e.ViewTrigger, "viewTrigger"), u = a(e.YearSelect, "yearSelect"), r = {
  Context: t,
  Root: g,
  ClearTrigger: n,
  Content: c,
  Control: T,
  Input: s,
  Label: P,
  MonthSelect: d,
  NextTrigger: b,
  Positioner: p,
  PresetTrigger: m,
  PrevTrigger: y,
  RangeText: C,
  TableBody: k,
  TableCell: D,
  TableCellTrigger: N,
  TableHead: w,
  TableHeader: x,
  Table: R,
  TableRow: V,
  Trigger: S,
  ViewControl: H,
  View: v,
  ViewTrigger: h,
  YearSelect: u
};
r.Root.displayName = "DatePickerRoot";
r.ClearTrigger.displayName = "DatePickerClearTrigger";
r.Content.displayName = "DatePickerContent";
r.Control.displayName = "DatePickerControl";
r.Input.displayName = "DatePickerInput";
r.Label.displayName = "DatePickerLabel";
r.MonthSelect.displayName = "DatePickerMonthSelect";
r.NextTrigger.displayName = "DatePickerNextTrigger";
r.Positioner.displayName = "DatePickerPositioner";
r.PresetTrigger.displayName = "DatePickerPresetTrigger";
r.PrevTrigger.displayName = "DatePickerPrevTrigger";
r.RangeText.displayName = "DatePickerRangeText";
r.TableBody.displayName = "DatePickerTableBody";
r.TableCell.displayName = "DatePickerTableCell";
r.TableCellTrigger.displayName = "DatePickerTableCellTrigger";
r.TableHead.displayName = "DatePickerTableHead";
r.TableHeader.displayName = "DatePickerTableHeader";
r.Table.displayName = "DatePickerTable";
r.TableRow.displayName = "DatePickerTableRow";
r.Trigger.displayName = "DatePickerTrigger";
r.ViewControl.displayName = "DatePickerViewControl";
r.View.displayName = "DatePickerView";
r.ViewTrigger.displayName = "DatePickerViewTrigger";
r.YearSelect.displayName = "DatePickerYearSelect";
export {
  r as DatePicker
};
